// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Q-cj","col":"styles_col__19rfv","fulfillmentStatus":"styles_fulfillmentStatus__1Ty_o","emailCol":"styles_emailCol__iVE4x"};